export default {
    type: 'service-modules',
    aliases: {
        camel: 'serviceModules',
        singular: 'Service module',
        plural: 'Service modules',
        lowerSingular: 'service module',
        lowerPlural: 'service modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
